// ToggleDisplay is a customized version of react-toggle-display
// see original: https://github.com/ccnokes/react-toggle-display/blob/master/ToggleDisplay.jsx
import React from 'react'
import PropTypes from 'prop-types'

ToggleDisplay.propTypes = {
  tag: PropTypes.string,
  hide: PropTypes.bool,
  show: PropTypes.bool,
  if: PropTypes.bool
}

ToggleDisplay.defaultProps = {
  tag: 'span'
}

const propsToRemove = Object.keys(ToggleDisplay.propTypes)

function shouldHide (props) {
  if (props.show != null) {
    return !props.show
  } else if (props.hide != null) {
    return props.hide
  }
  return false
}

function pickProps (props) {
  const newProps = Object.assign({}, props)
  propsToRemove.forEach(prop => {
    if (prop in newProps) {
      delete newProps[prop]
    }
  })
  return newProps
}

export default function ToggleDisplay (props) {
  if (props.if === false) {
    return <noscript />
    // return null // this used to work, now have to manually return <noscript>
  }

  let style = {}
  if (shouldHide(props)) {
    style.display = 'none'
  }

  const Tag = props.tag
  // prevent our props from being leaked down onto the children
  const newProps = pickProps(props)

  return (
    <Tag style={style} {...newProps} />
  )
}



// WEBPACK FOOTER //
// ./src/components/toggle-display/index.js